import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router';

import {
  HOUSEHOLD_LISTING_STATUS_ARCHIVED,
  HOUSEHOLD_STATUS_ARCHIVED,
} from 'common/householdConstants';

import SrListingThumbnail from 'client/components/SrListingThumbnail';
import SrRenterApplicationStatusSteps from 'client/components/SrRenterApplicationStatusSteps';

import branch from 'client/core/branch';

@withRouter
@branch({
  listingPhotoResolution: ['listingPhotoResolution'],
  currentUser: ['currentUser'],
  appUrl: ['env', 'APP_URL'],
  typeformIdRenterLeaseSigned: ['env', 'TYPEFORM_ID_RENTER_LEASE_SIGNED'],
})
class SrRenterApplicationStatusCardSunroom extends Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
    partner: PropTypes.object,
    concession: PropTypes.object,
    household: PropTypes.object.isRequired,
    moveInDate: PropTypes.string.isRequired,
    householdListing: PropTypes.object.isRequired,
    householdUsers: PropTypes.array.isRequired,
    roommateApplications: PropTypes.array.isRequired,
    guarantorApplications: PropTypes.array.isRequired,
    applicationSubmissions: PropTypes.array.isRequired,
    securityDepositPaymentAccount: PropTypes.object,
    defaultPaymentAccount: PropTypes.object,
    typeformIdRenterLeaseSigned: PropTypes.string,
    householdApplicationsStatusUpdates: PropTypes.array.isRequired,
    onInviteRoommateClicked: PropTypes.func,
    currentUser: PropTypes.object.isRequired,
    listingPhotoResolution: PropTypes.number.isRequired,
    lease: PropTypes.object,
    marketingPartnerListing: PropTypes.object,
    market: PropTypes.object,
    viewing: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    viewingUserId: PropTypes.number,
  }

  render() {
    const {
      listing,
      partner,
      concession,
      household,
      moveInDate,
      householdListing,
      householdUsers,
      roommateApplications,
      guarantorApplications,
      applicationSubmissions,
      securityDepositStripeCharge,
      securityDepositPaymentAccount,
      defaultPaymentAccount,
      typeformIdRenterLeaseSigned,
      householdApplicationsStatusUpdates,
      tenantScreeningCriteria,
      tenantAlertReports,
      householdGuarantors,
      renters,
      lease,
      marketingPartnerListing,
      market,
      onInviteRoommateClicked,
      currentUser,
      listingPhotoResolution,
      dispatch,
      history,
      appUrl,
      viewing,
      viewingUserId,
    } = this.props;

    const isHouseholdListingArchived = (
      householdListing.status === HOUSEHOLD_LISTING_STATUS_ARCHIVED
      || household.status === HOUSEHOLD_STATUS_ARCHIVED
    );

    return (
      <div
        className={classnames(
          'SrRenterApplicationStatusCardSunroom',
          `SrRenterApplicationStatusCardSunroom-listing-${listing.id}`
        )}
      >
        <SrListingThumbnail
          key={listing.id}
          className={isHouseholdListingArchived ? 'archived' : null}
          listing={listing}
          currentUser={currentUser}
          concession={concession}
          showAutomatedListingStatus={false}
          showRequestShowingButton={false}
          showAvailableDate={false}
          photoResolution={listingPhotoResolution}
          disableDefaultApplicationStatusMessage
          showThumbnailListingAddress
        />
        <SrRenterApplicationStatusSteps
          listing={listing}
          partner={partner}
          moveInDate={moveInDate}
          householdListing={householdListing}
          householdUsers={householdUsers}
          roommateApplications={roommateApplications}
          guarantorApplications={guarantorApplications}
          applicationSubmissions={applicationSubmissions}
          securityDepositStripeCharge={securityDepositStripeCharge}
          securityDepositPaymentAccount={securityDepositPaymentAccount}
          defaultPaymentAccount={defaultPaymentAccount}
          householdApplicationsStatusUpdates={householdApplicationsStatusUpdates}
          lease={lease}
          marketingPartnerListing={marketingPartnerListing}
          market={market}
          tenantScreeningCriteria={tenantScreeningCriteria}
          tenantAlertReports={tenantAlertReports}
          householdGuarantors={householdGuarantors}
          household={household}
          renters={renters}
          onInviteRoommateClicked={onInviteRoommateClicked}
          currentUser={currentUser}
          dispatch={dispatch}
          history={history}
          appUrl={appUrl}
          typeformIdRenterLeaseSigned={typeformIdRenterLeaseSigned}
          viewing={viewing}
          viewingUserId={viewingUserId}
        />
      </div>
    );
  }
}

SrRenterApplicationStatusCardSunroom.displayName = 'SrRenterApplicationStatusCardSunroom';

export default SrRenterApplicationStatusCardSunroom;
